/**
 * 获取cookie
 * @param {*} cname cookie的名称
 * @param {*} req ctx中的req
 */
export const getCookie = function (cname, req) {
    let name = cname + "="
    let decodedCookie
    decodedCookie = decodeURIComponent(document.cookie)
    let ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
            return { target: c.substring(name.length, c.length), all: decodedCookie }
        }
    }
    return { target: "", all: "" }
}
/**
 * 删除cookie
 * @param key
 */
export const delCookie = (key="ssoToken") => {
    document.cookie = `${key}=0;path=/;expires=${new Date(0).toUTCString()}`; // 清除当前域名下的,例如：m.xx.cn
    document.cookie = `${key}=0;path=/;expires=${new Date(0).toUTCString()};domain=${window.location.hostname}`;
}